import slimvue from 'slimvue';
import App     from 'website/components/App.vue';

slimvue.mount(App);



// WEBPACK FOOTER //
// ./website/entries/index.js